<template>
  <v-container grid-list-md class="py-0 px-2 ma-0">
    <v-row>
      <v-col cols="12" class="pt-0">
        <v-card flat v-if="lAction === 'view'">
          <v-card-title class="px-0">
            <v-layout row wrap>
              <v-flex xs10>
                <v-text-field
                class="pa-0 mt-1"
                append-icon="mdi-account-search-outline"
                :placeholder="$vuetify.breakpoint.smAndUp?'Search project name':'Search'"
                single-line
                hide-details
                v-model="search"
                @input="searchProjectTile(search)"
                outlined
                clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs2 class="text-right pt-4">
                <v-chip :class="isClosedProject ? 'info dark' : '' " @click="showClosedProjects()">Show Closed Projects</v-chip>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="px-0">
            <v-flex xs12>
              <v-card>
                <v-expansion-panels :value="selTab">
                  <v-expansion-panel v-for="(proj_name, i) in salesProjList" :key="i">
                    <v-expansion-panel-header style="min-height: 40px;" class="py-0 grey lighten-4">
                      <div class="subtitle">{{proj_name}}</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="pt-3">
                      <v-data-table
                      :headers="salesHead"
                      :items="lSalesList.filter(rec => rec.proj_name === proj_name)"
                      hide-default-footer
                      dense
                      disable-pagination
                      :mobile-breakpoint="0"
                      class="elevation-1">
                      <template slot="item" slot-scope="props">
                        <tr @click="prepareUpdate(props.item)" :class="props.item.proj_status === 'Closed' ? 'grey--text' : ''">
                          <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                          <td style="font-size: 12px;">{{ props.item.current_dept }}</td>
                          <td style="font-size: 12px;">{{ props.item.version_no }}</td>
                          <td style="font-size: 12px;">{{ props.item.project_contract_version ? props.item.project_contract_version : '-' }}</td>
                          <td style="font-size: 12px;">{{ props.item.contract_amt_with_tax ? handy.formatCur(props.item.contract_amt_with_tax) : '-' }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>

      <v-btn
      :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:15px;':'bottom:15px; right:15px;')"
      dark fab fixed color="accent" v-if="lAction === 'view' && config.IS_EDITED_BY_USER && config.IS_VIEWED_BY_USER"
      @click.native="prepareCreate"><v-icon>mdi-playlist-plus</v-icon></v-btn>

      <!-- 1. create, update and delete of project contract -->
      <v-container v-if="lAction === 'create' || lAction === 'update'" class="pa-0" fluid full-height>
        <v-layout row wrap>
          <v-flex xs12 class="mt-2">
            <v-form ref="pForm" @submit.prevent="saveSalesReviewBaseChanges(lAction)">
              <v-card>
                <v-card-title class="py-2 grey lighten-4">
                  <v-btn small icon @click="lAction = 'view'"><v-icon>mdi-arrow-left</v-icon></v-btn>
                  <span class="body-1 font-weight-bold pl-2 primary--text">{{ handy.startWithUpper(lAction) + ' Sales Review' }}</span>
                </v-card-title>
                <v-card-text class="pb-0 pt-2">
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs2>
                        <v-combobox
                        v-model="lSalesBase.comm_pair"
                        :items="commList"
                        item-text="comm_name"
                        item-value="comm_id"
                        label="Community"
                        hide-details
                        dense
                        outlined
                        small-chips
                        color="primary"
                        :disabled="lAction === 'update'"
                        @input="loadProjectBasedOnCommId(lSalesBase)"
                        ></v-combobox>
                      </v-flex>
                      <v-flex xs1 style="flex-basis: 0%" class="pt-3">
                        <v-btn small icon :disabled="!lSalesBase.comm_pair.comm_id" @click="showBasicInformationOfCommunity(lSalesBase)"><v-icon>mdi-information-outline</v-icon></v-btn>
                      </v-flex>
                      <v-flex xs2>
                        <v-combobox
                        v-model="lSalesBase.proj_pair"
                        :items="projList"
                        item-text="proj_name"
                        item-value="proj_id"
                        label="Project"
                        hide-details
                        dense
                        outlined
                        small-chips
                        color="primary"
                        :disabled="lAction === 'update'"
                        @input="loadProjectContractBasedOnProjId(lSalesBase)"
                        ></v-combobox>
                      </v-flex>
                      <v-flex xs1 style="flex-basis: 0%" class="pt-3">
                        <v-btn small icon :disabled="!lSalesBase.proj_pair.proj_id" @click="showBasicInformationOfProject(lSalesBase)"><v-icon>mdi-information-outline</v-icon></v-btn>
                      </v-flex>
                      <v-flex xs2>
                        <v-select
                        v-model="lSalesBase.proj_contract_base_id"
                        :items="projContractList"
                        item-text="proj_name"
                        item-value="proj_contract_base_id"
                        label="Project Contract Ver"
                        hide-details
                        dense
                        outlined
                        :disabled="disableSubmitButton"
                        small-chips
                        ></v-select>
                      </v-flex>
                      <v-flex xs1 style="flex-basis: 0%" class="pt-3">
                        <v-btn small icon :disabled="!lSalesBase.proj_contract_base_id" @click="showBasicInformationOfProjectContract(lSalesBase)"><v-icon>mdi-information-outline</v-icon></v-btn>
                      </v-flex>
                      <v-flex xs2>
                        <v-dialog ref="dlgDate"
                        persistent v-model="dlgDate"
                        max-width="290px"
                        :return-value.sync="lSalesBase.on_boarding_date">
                        <template v-slot:activator="{ on }">
                          <v-text-field
                          slot="activator" label="On-boarding Date"
                          v-model="lSalesBase.on_boarding_date" append-icon="mdi-calendar-today"
                          readonly
                          v-on="on"
                          hide-details
                          outlined
                          dense
                          :disabled="disableSubmitButton"
                          color="primary"
                          style="font-size: 12px"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="lSalesBase.on_boarding_date"
                        :disabled="disableSubmitButton"
                        first-day-of-week="1">
                        <v-spacer></v-spacer>
                        <v-btn text @click="dlgDate = false">Cancel</v-btn>
                        <v-btn text color="accent" @click="$refs.dlgDate.save(lSalesBase.on_boarding_date)">OK</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-flex>
                  <v-flex xs2 v-if="lAction === 'update'">
                    <v-select
                    v-model="lVersion"
                    label="Select Your Sales Review Version"
                    :items="versionList"
                    item-text="version"
                    item-value="mi_base_id"
                    hide-details
                    outlined
                    dense
                    color="primary"
                    @input="loadTheDetailsAndBaseThingsBasedOnSelectedVersion(lVersion)"
                    >
                  </v-select>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small :disabled="salesReviewItemList.length > 0 || voiceOfCustItemList.length > 0 || custExpectItemList.length > 0 || uniCommitItemList.length > 0 || docItemList.length > 0" v-if="lAction === 'update' && config.IS_EDITED_BY_USER && config.IS_VIEWED_BY_USER" @click="deleteSalesBaseTable(lSalesBase)">delete</v-btn>
            <v-btn small :disabled="disableSubmitButton" class="accent" v-if="config.IS_EDITED_BY_USER && config.IS_VIEWED_BY_USER" type="submit">save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
    <v-flex xs12 v-if="lSalesBase.mi_base_id">
      <v-card>
        <v-card-text>
          <v-expansion-panels :value="selTab">
            <v-expansion-panel>
              <v-expansion-panel-header style="min-height: 40px;" class="py-0 grey lighten-4">
                <div class="subtitle font-weight-bold">Sales Review</div>
                <v-flex xs2 class="text-right" v-if="config.IS_EDITED_BY_USER && config.IS_VIEWED_BY_USER">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" class="warning--text" icon small :disabled="disableSubmitButton" @click="prepareCreateSales()"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                    </template>
                    <span>Add New</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" class="ml-4 warning--text" icon small :disabled="disableSubmitButton" @click="parepareSalesReviewImport(salesReviewItemList)"><v-icon>mdi-table-arrow-down</v-icon></v-btn>
                    </template>
                    <span>Import</span>
                  </v-tooltip>
                </v-flex>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="mt-2 px-0">
                <v-expansion-panels :value="selTab1">
                  <v-expansion-panel v-for="(cat, i) in salesCat" :key="i">
                    <v-expansion-panel-header style="min-height: 40px;" class="py-0 grey lighten-4">
                      <div class="body-2">
                        {{cat}}
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="mt-2 px-0">
                      <v-data-table
                      :headers="salesReviewHeadList"
                      :items="salesReviewItemList.filter(rec => rec.sales_review_cat === cat)"
                      hide-default-footer
                      disable-pagination
                      dense
                      :mobile-breakpoint="0">
                      <template slot="item" slot-scope="props">
                        <tr @click="disableSubmitButton ? '' : prepareSalesUpdate(props.item)">
                          <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                          <td style="font-size: 12px;">{{ props.item.sales_review_sub_cat }}</td>
                          <td style="font-size: 12px;">{{ props.item.sales_review_uniservice_remarks }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header style="min-height: 40px;" class="py-0 grey lighten-4">
              <div class="subtitle font-weight-bold">Voice Of Customer</div>
              <v-flex xs2 class="text-right" v-if="config.IS_EDITED_BY_USER && config.IS_VIEWED_BY_USER">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="warning--text" icon small :disabled="disableSubmitButton" @click="prepareCreateVoiceofCust()"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                  </template>
                  <span>Add New</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="ml-4 warning--text" icon small :disabled="disableSubmitButton" @click="parepareVoiceofCustImport(voiceOfCustItemList)"><v-icon>mdi-table-arrow-down</v-icon></v-btn>
                  </template>
                  <span>Import</span>
                </v-tooltip>
              </v-flex>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-data-table
              :headers="salesReviewHeadList"
              :items="voiceOfCustItemList"
              hide-default-footer
              disable-pagination
              dense
              :mobile-breakpoint="0">
              <template slot="item" slot-scope="props">
                <tr @click="disableSubmitButton ? '' : prepareVoiceUpdate(props.item)">
                  <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                  <td style="font-size: 12px;">{{ props.item.mi_voice_of_cust }}</td>
                  <td style="font-size: 12px;">{{ props.item.mi_voice_of_cust_remarks }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header style="min-height: 40px;" class="py-0 grey lighten-4">
            <div class="subtitle font-weight-bold">Customer Expectations</div>
            <v-flex xs2 class="text-right" v-if="config.IS_EDITED_BY_USER && config.IS_VIEWED_BY_USER">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" class="warning--text" icon small :disabled="disableSubmitButton" @click="prepareCreateCustExpect()"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                </template>
                <span>Add New</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" class="ml-4 warning--text" icon small :disabled="disableSubmitButton" @click="parepareCustExpectImport(custExpectItemList)"><v-icon>mdi-table-arrow-down</v-icon></v-btn>
                </template>
                <span>Import</span>
              </v-tooltip>
            </v-flex>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-data-table
            :headers="custExpectHeadList"
            :items="custExpectItemList"
            hide-default-footer
            disable-pagination
            dense
            :mobile-breakpoint="0">
            <template slot="item" slot-scope="props">
              <tr @click="disableSubmitButton ? '' : prepareCustExpectUpdate(props.item)">
                <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                <td style="font-size: 12px;">{{ props.item.category }}</td>
                <td style="font-size: 12px;">{{ props.item.mi_cust_expectation }}</td>
                <td style="font-size: 12px;">{{ props.item.mi_freq }}</td>
                <td style="font-size: 12px;">{{ props.item.mi_cust_expect_remarks }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header style="min-height: 40px;" class="py-0 grey lighten-4">
          <div class="subtitle font-weight-bold">Uniservice Commitment</div>
          <v-flex xs2 class="text-right" v-if="config.IS_EDITED_BY_USER && config.IS_VIEWED_BY_USER">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" class="warning--text" icon small :disabled="disableSubmitButton" @click="prepareCreateUniCommit()"><v-icon>mdi-playlist-plus</v-icon></v-btn>
              </template>
              <span>Add New</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" class="ml-4 warning--text" icon small :disabled="disableSubmitButton" @click="parepareUniCommitImport(uniCommitItemList)"><v-icon>mdi-table-arrow-down</v-icon></v-btn>
              </template>
              <span>Import</span>
            </v-tooltip>
          </v-flex>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-data-table
          :headers="custExpectHeadList"
          :items="uniCommitItemList"
          hide-default-footer
          disable-pagination
          dense
          :mobile-breakpoint="0">
          <template slot="item" slot-scope="props">
            <tr @click="disableSubmitButton ? '' : prepareUniCommitUpdate(props.item)">
              <td style="font-size: 12px;">{{ props.index + 1 }}</td>
              <td style="font-size: 12px;">{{ props.item.category }}</td>
              <td style="font-size: 12px;">{{ props.item.mi_uni_commit }}</td>
              <td style="font-size: 12px;">{{ props.item.mi_freq }}</td>
              <td style="font-size: 12px;">{{ props.item.mi_uni_commit_remarks }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel>
      <v-expansion-panel-header style="min-height: 40px;" class="py-0 grey lighten-4">
        <div class="subtitle font-weight-bold">Documents</div>
        <v-flex xs2 class="text-right" v-if="config.IS_EDITED_BY_USER && config.IS_VIEWED_BY_USER">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" class="warning--text" icon small :disabled="disableSubmitButton" @click="parepareUploadDocuments()"><v-icon>mdi-playlist-plus</v-icon></v-btn>
            </template>
            <span>Add New Document</span>
          </v-tooltip>
        </v-flex>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-data-table
        :headers="docHeadList"
        :items="docItemList"
        hide-default-footer
        disable-pagination
        dense
        :mobile-breakpoint="0">
        <template slot="item" slot-scope="props">
          <tr>
            <td style="font-size: 12px;">{{ props.index + 1 }}</td>
            <td style="font-size: 12px;">{{ props.item.file_name }}</td>
            <td><a :href="handy.loadImg(props.item.file_url)" download style="text-decoration: none;">
              <v-btn small icon class="mr-1 info grey--text text--lighten-4">
                <v-icon small>mdi-download</v-icon>
              </v-btn>
            </a></td>
            <td style="font-size: 12px;">{{ props.item.mi_doc_remarks }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-expansion-panel-content>
  </v-expansion-panel>
</v-expansion-panels>
</v-card-text>
<v-card-actions>
  <v-spacer></v-spacer>
  <v-btn small v-if="config.IS_EDITED_BY_USER && config.IS_VIEWED_BY_USER" class="success" :disabled="disableSubmitButton || (salesReviewItemList.length === 0 && voiceOfCustItemList.length === 0 && custExpectItemList.length === 0 && uniCommitItemList.length === 0 && docItemList.length === 0)" @click="SaveAllTheSalesChanges()">save</v-btn>
  <v-btn small v-if="config.IS_EDITED_BY_USER && config.IS_VIEWED_BY_USER" class="warning" :disabled="disableSubmitButton || (salesReviewItemList.length === 0 && voiceOfCustItemList.length === 0 && custExpectItemList.length === 0 && uniCommitItemList.length === 0 && docItemList.length === 0)" @click="changeTheStatusOfCurrentSalesReview()">Submit to Onboarding</v-btn>
  <v-btn small class="uniformchipinfo white--text" @click="showSalesReview = true">view</v-btn>
</v-card-actions>
</v-card>
</v-flex>
</v-layout>
</v-container>

<!-- 2. Add New Items to Sales Review -->
<v-dialog v-model="showListOfSalesReviewDet" persistent scrollable max-width="600px">
  <v-card>
    <v-card-title class="py-2 grey lighten-4">
      Select Sales review
      <v-spacer></v-spacer>
      <v-btn icon small @click="showListOfSalesReviewDet = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-3">
      <v-data-table
      v-model="selected"
      show-select
      :headers="salesReviewDetHeadList"
      :items="salesReviewDetList"
      hide-default-footer
      disable-sort
      disable-pagination
      dense
      item-key="mi_sales_sub_cat_id"
      class="elevation-1"
      :mobile-break-point="0">
    </v-data-table>
  </v-card-text>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn class="accent" :disabled="beingSaved" @click="importToSalesReview(selected)">Import to Sales Review</v-btn>
  </v-card-actions>
</v-card>
</v-dialog>

<!-- 3. Add New Items to Voice of cust -->
<v-dialog v-model="showListOfVoiceofCustDet" persistent scrollable max-width="600px">
  <v-card>
    <v-card-title class="py-2 grey lighten-4">
      Select Voice of Customer
      <v-spacer></v-spacer>
      <v-btn icon small @click="showListOfVoiceofCustDet = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-3">
      <v-data-table
      v-model="selected"
      show-select
      :headers="voiceofCustDetHeadList"
      :items="voiceOfCustDetList"
      hide-default-footer
      disable-sort
      disable-pagination
      dense
      item-key="mi_voice_of_customer_id"
      class="elevation-1"
      :mobile-break-point="0">
    </v-data-table>
  </v-card-text>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn class="accent" :disabled="beingSaved" @click="importToVoiceOfCust(selected)">Import to Voice of Customer</v-btn>
  </v-card-actions>
</v-card>
</v-dialog>

<!-- 4. add New Items to Customer Expectations -->
<v-dialog v-model="showListOfCustExpectDet" persistent scrollable max-width="700px">
  <v-card>
    <v-card-title class="py-2 grey lighten-4">
      Select Customer Expectation
      <v-spacer></v-spacer>
      <v-btn icon small @click="showListOfCustExpectDet = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-3">
      <v-data-table
      v-model="selected"
      show-select
      :headers="custExpectDetHeadList"
      :items="custExpectDetList"
      hide-default-footer
      disable-sort
      disable-pagination
      dense
      item-key="mi_customer_expectation_id"
      class="elevation-1"
      :mobile-break-point="0">
    </v-data-table>
  </v-card-text>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn class="accent" :disabled="beingSaved" @click="importToCustExpect(selected)">Import to Customer Expectations</v-btn>
  </v-card-actions>
</v-card>
</v-dialog>

<!-- 5. add New Items to Uniservice Commitment -->
<v-dialog v-model="showListOfUniCommitDet" persistent scrollable max-width="700px">
  <v-card>
    <v-card-title class="py-2 grey lighten-4">
      Select Uniservice Commitment
      <v-spacer></v-spacer>
      <v-btn icon small @click="showListOfUniCommitDet = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-3">
      <v-data-table
      v-model="selected"
      show-select
      :headers="uniCommitDetHeadList"
      :items="uniCommitDetList"
      hide-default-footer
      disable-sort
      disable-pagination
      dense
      item-key="mi_uniservice_commit_id"
      class="elevation-1"
      :mobile-break-point="0">
    </v-data-table>
  </v-card-text>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn class="accent" :disabled="beingSaved" @click="importToUniCommitment(selected)">Import to Uniservice Commitment</v-btn>
  </v-card-actions>
</v-card>
</v-dialog>

<!-- 6. Upload Documents -->
<v-dialog v-model="showSalesDocUpload" persistent scrollable max-width="700px">
  <v-card>
    <v-card-title class="py-2 grey lighten-4">
      Documents Upload
      <v-spacer></v-spacer>
      <v-btn icon small @click="showSalesDocUpload = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-3">
      <v-flex xs12>
        <input style="display:none" type="file" ref="fileInput"
        accept=".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg" multiple @change="loadFilesFromFileBrowser(lUploadDoc)"/>
        <v-btn icon @click="pickFile"><v-icon>mdi-attachment</v-icon></v-btn>
        <span v-if="lUploadDoc.files && lUploadDoc.files.filter(rec => rec.is_selected).length > 0">
          <span v-for="(file, index) in lUploadDoc.files.filter(rec => rec.is_selected)" :key="index">
            <v-chip style="font-size: 12px;" v-model="file.is_selected" @click:close="removeSelectedFile(file)" @input="$forceUpdate()" close>{{ file.file_name }}</v-chip>
          </span>
        </span>
        <span v-else>Attachment if any<br /><span class="caption">(supports images, pdfs, docs and excels upto 20MB)</span></span>
      </v-flex>
      <v-flex xs12>
        <v-text-field
        v-model="lUploadDoc.mi_doc_remarks"
        label="Doc Type / Remarks"
        hide-details
        :rules="[rules.required]"
        ></v-text-field>
      </v-flex>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="accent" :disabled="beingSaved" @click="saveUploadedDocs()">Save</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- 7. Add or update sales sub dategory -->
<v-dialog v-model="showSales" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12>
      <v-form ref="lForm" @submit.prevent="pushSalesChanges()">
        <v-card scrollable>
          <v-card-title class="title grey lighten-4 py-2">
            {{lSales.action ? handy.startWithUpper(lSales.action) : ''}} Sales
            <v-spacer></v-spacer>
            <v-btn icon small @click.stop="showSales = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                v-model="lSales.sales_review_cat"
                label="Sales Category"
                hide-details
                maxlength="100"
                :disabled="lSales.action === 'update'"
                :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lSales.sales_review_sub_cat"
                label="Sales Sub Category"
                hide-details
                maxlength="100"
                :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lSales.sales_review_uniservice_remarks"
                label="Add Remarks if any?"
                hide-details
                maxlength="100"
                :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn type="submit" color="accent" v-if="config.IS_EDITED_BY_USER && config.IS_VIEWED_BY_USER">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!-- 8. Add or update Voice of customer -->
<v-dialog v-model="showVoice" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12>
      <v-form ref="lForm" @submit.prevent="pushVoiceChanges()">
        <v-card scrollable>
          <v-card-title class="title grey lighten-4 py-2">
            {{lVoice.action ? handy.startWithUpper(lVoice.action) : ''}} Voice of Customer
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                v-model="lVoice.mi_voice_of_cust"
                label="Voice of Customer Questions"
                hide-details
                maxlength="100"
                :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lVoice.mi_voice_of_cust_remarks"
                label="Remarks if any?"
                hide-details
                maxlength="100"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn @click.stop="showVoice = false">Cancel</v-btn>
            <v-btn type="submit" color="accent" v-if="config.IS_EDITED_BY_USER && config.IS_VIEWED_BY_USER">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!-- 9. Add or update customer expectation -->
<v-dialog v-model="showCust" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12>
      <v-form ref="lForm" @submit.prevent="pushCustChanges()">
        <v-card scrollable>
          <v-card-title class="title grey lighten-4 py-2">
            Add Customer Expectations
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-select
                v-model="lCust.category"
                label="Category"
                :items="['MANAGEMENT/OFFICE', 'TECHNICAL SERVICES', 'SOFT SERVICES', 'SAFTY/SECURITY', 'OTHERS']"
                hide-details
                :rules="[rules.required]"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lCust.mi_cust_expectation"
                label="Commitment Description"
                hide-details
                maxlength="200"
                :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                v-model="lCust.mi_freq_id"
                :items="freqItem"
                item-value="mi_freq_id"
                item-text="mi_freq"
                label="Frequency"
                hide-details
                :rules="[rules.required]"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lCust.mi_cust_expect_remarks"
                label="Add Remarks if any?"
                hide-details
                maxlength="100"
                :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn @click.stop="showCust = false">Cancel</v-btn>
            <v-btn type="submit" color="accent" v-if="config.IS_EDITED_BY_USER && config.IS_VIEWED_BY_USER">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!-- 10. Add or update customer expectation -->
<v-dialog v-model="showUniserviceCommit" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12>
      <v-form ref="lForm" @submit.prevent="pushUniserviceCommitChanges()">
        <v-card scrollable>
          <v-card-title class="title grey lighten-4 py-2">
            Add Uniservice Commitment
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-select
                v-model="lUniCommit.category"
                label="Category"
                :items="['MANAGEMENT/OFFICE', 'TECHNICAL SERVICES', 'SOFT SERVICES', 'SAFTY/SECURITY', 'OTHERS']"
                hide-details
                :rules="[rules.required]"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lUniCommit.mi_uni_commit"
                label="Commitment Description"
                hide-details
                maxlength="200"
                :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                v-model="lUniCommit.mi_freq_id"
                :items="freqItem"
                item-value="mi_freq_id"
                item-text="mi_freq"
                label="Frequency"
                hide-details
                :rules="[rules.required]"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lUniCommit.mi_uni_commit_remarks"
                label="Add Remarks if any?"
                hide-details
                maxlength="100"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn @click.stop="showUniserviceCommit = false">Cancel</v-btn>
            <v-btn type="submit" color="accent" v-if="config.IS_EDITED_BY_USER && config.IS_VIEWED_BY_USER">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!-- 11. Basic Information of Commnunity -->
<v-dialog v-model="showCommunity" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12>
      <v-card>
        <v-card-title class="title py-0 grey lighten-3">
          Basic Information of Community
          <v-spacer></v-spacer>
          <v-btn icon @click="showCommunity = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pb-1 body-1">
          <v-container grid-list-md class="pa-2">
            <v-layout row wrap>
              <v-flex xs6>
                <span class="caption grey--text">Community Id.</span><br />
                <span class="black--text">{{ commDetailsList.comm_id }}</span>
              </v-flex>
              <v-flex xs6>
                <span class="caption grey--text">Community Name</span><br />
                <span class="black--text">{{ commDetailsList.comm_name }}</span>
              </v-flex>
              <v-flex xs6>
                <span class="caption grey--text">Community Type</span><br />
                <span class="black--text">{{commDetailsList.comm_type}}</span>
              </v-flex>
              <v-flex xs6>
                <span class="caption grey--text">Community Address</span><br />
                <span class="black--text">{{commDetailsList.address}}</span>
              </v-flex>
              <v-flex xs6>
                <span class="caption grey--text">No of Units</span><br />
                <span class="black--text">{{commDetailsList.no_of_unit}}</span>
              </v-flex>
              <v-flex xs6>
                <span class="caption grey--text">Customer Since</span><br />
                <span class="black--text">{{commDetailsList.cust_since ? handy.formatDate(commDetailsList.cust_since) : ''}}</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-container>
</v-dialog>

<!-- 12. Basic Information of Project -->
<v-dialog v-model="showProject" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12>
      <v-card>
        <v-card-title class="title py-0 grey lighten-3">
          Basic Information of Project
          <v-spacer></v-spacer>
          <v-btn icon @click="showProject = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pb-1 body-1">
          <v-container grid-list-md class="pa-2">
            <v-layout row wrap>
              <v-flex xs6>
                <span class="caption grey--text">Project Id.</span><br />
                <span class="black--text">{{ projDetailsList.proj_id }}</span>
              </v-flex>
              <v-flex xs6>
                <span class="caption grey--text">Project Name</span><br />
                <span class="black--text">{{ projDetailsList.proj_name }}</span>
              </v-flex>
              <v-flex xs6>
                <span class="caption grey--text">Project Type</span><br />
                <span class="black--text">{{projDetailsList.proj_type}}</span>
              </v-flex>
              <v-flex xs6>
                <span class="caption grey--text">Project Status</span><br />
                <span class="black--text">{{projDetailsList.proj_status}}</span>
              </v-flex>
              <v-flex xs6>
                <span class="caption grey--text">Project Manager</span><br />
                <span class="black--text">{{projDetailsList.emp_name}}</span>
              </v-flex>
              <v-flex xs6>
                <span class="caption grey--text">Project Start</span><br />
                <span class="black--text">{{projDetailsList.proj_start ? handy.formatDate(projDetailsList.proj_start) : ''}}</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-container>
</v-dialog>

<!-- 13. basic information of prject contract -->
<v-dialog v-model="showProjectContract" persistent max-width="600px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12>
      <v-card>
        <v-card-title class="title py-0 grey lighten-3">
          Basic Information of Project Contract
          <v-spacer></v-spacer>
          <v-btn icon @click="showProjectContract = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pb-1 body-1">
          <v-container grid-list-md class="pa-2">
            <v-layout row wrap>
              <v-flex xs6>
                <v-spacer></v-spacer>
              </v-flex>
              <v-flex xs6>
                <v-btn small class="accent" @click="prepareViewProjContract(lSalesBase)">Project Contract Detailed View</v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <span class="caption grey--text">Project Contract Id.</span><br />
                <span class="black--text">{{ projContractDetailsList.proj_contract_base_id }}</span>
              </v-flex>
              <v-flex xs6>
                <span class="caption grey--text">Project Contract HeadCount</span><br />
                <span class="black--text">{{projContractDetailsList.head_count}}</span>
              </v-flex>
              <v-flex xs6>
                <span class="caption grey--text">Project Contract Status</span><br />
                <span class="black--text">{{ projContractDetailsList.status }}</span>
              </v-flex>
              <v-flex xs6>
                <span class="caption grey--text">Project Contract Version</span><br />
                <span class="black--text">{{projContractDetailsList.version + '.0'}}</span>
              </v-flex>
              <v-flex xs6>
                <span class="caption grey--text">Project Contract Created By</span><br />
                <span class="black--text">{{projContractDetailsList.update_by_name + ' on ' + handy.formatDate(projContractDetailsList.updated_date)}}</span>
              </v-flex>
              <v-flex xs6>
                <span class="caption grey--text">Project Contract Value</span><br />
                <span class="black--text">{{projContractDetailsList.contract_value_with_gst ? handy.formatCur(projContractDetailsList.contract_value_with_gst) : ''}}</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-container>
</v-dialog>

<!-- 14. sales review view dialog -->
<v-dialog v-model="showSalesReview" persistent max-width="950px">
  <v-card>
    <v-card-title class="py-0 grey lighten-4">
      <div class="subtitle font-weight-bold">View Sales Review</div>
      <v-spacer></v-spacer>
      <v-btn icon @click="showSalesReview = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pt-4">
      <v-card :class="i > 0 ? 'mt-2' : ''" v-for="(cat, i) in salesCat" :key="i">
        <v-card-title class="body-2 font-weight-bold grey lighten-4 py-2">
          {{cat}}
        </v-card-title>
        <v-card-text>
          <v-data-table
          :headers="salesReviewHeadList"
          :items="salesReviewItemList.filter(rec => rec.sales_review_cat === cat)"
          hide-default-footer
          disable-pagination
          dense
          :mobile-breakpoint="0">
          <template slot="item" slot-scope="props">
            <tr>
              <td style="font-size: 12px;">{{ props.index + 1 }}</td>
              <td style="font-size: 12px;">{{ props.item.sales_review_sub_cat }}</td>
              <td style="font-size: 12px;">{{ props.item.sales_review_uniservice_remarks }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-card class="mt-2">
      <v-card-title class="grey lighten-4 py-2">
        <div class="body-2 font-weight-bold">Voice Of Customer</div>
      </v-card-title>
      <v-card-text>
        <v-data-table
        :headers="salesReviewHeadList"
        :items="voiceOfCustItemList"
        hide-default-footer
        disable-pagination
        dense
        :mobile-breakpoint="0">
        <template slot="item" slot-scope="props">
          <tr>
            <td style="font-size: 12px;">{{ props.index + 1 }}</td>
            <td style="font-size: 12px;">{{ props.item.sales_review_voice_of_cust }}</td>
            <td style="font-size: 12px;">{{ props.item.sales_review_voice_of_cust_remarks }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
  <v-card class="mt-2">
    <v-card-title class="grey lighten-4 py-2">
      <div class="body-2 font-weight-bold">Customer Expectations</div>
    </v-card-title>
    <v-card-text>
      <v-data-table
      :headers="custExpectHeadList"
      :items="custExpectItemList"
      hide-default-footer
      disable-pagination
      dense
      :mobile-breakpoint="0">
      <template slot="item" slot-scope="props">
        <tr>
          <td style="font-size: 12px;">{{ props.index + 1 }}</td>
          <td style="font-size: 12px;">{{ props.item.category }}</td>
          <td style="font-size: 12px;">{{ props.item.mi_cust_expectation }}</td>
          <td style="font-size: 12px;">{{ props.item.mi_freq }}</td>
          <td style="font-size: 12px;">{{ props.item.sales_review_cust_expect_remarks }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
<v-card class="mt-2">
  <v-card-title class="grey lighten-4 py-2">
    <div class="body-2 font-weight-bold">Uniservice Commitment</div>
  </v-card-title>
  <v-card-text>
    <v-data-table
    :headers="custExpectHeadList"
    :items="uniCommitItemList"
    hide-default-footer
    disable-pagination
    dense
    :mobile-breakpoint="0">
    <template slot="item" slot-scope="props">
      <tr>
        <td style="font-size: 12px;">{{ props.index + 1 }}</td>
        <td style="font-size: 12px;">{{ props.item.category }}</td>
        <td style="font-size: 12px;">{{ props.item.sv_sales_review_uni_commit }}</td>
        <td style="font-size: 12px;">{{ props.item.mi_freq }}</td>
        <td style="font-size: 12px;">{{ props.item.sales_review_uni_commit_remarks }}</td>
      </tr>
    </template>
  </v-data-table>
</v-card-text>
</v-card>
<v-card class="mt-2">
  <v-card-title class="grey lighten-4 py-2">
    <div class="body-2 font-weight-bold">Documents</div>
  </v-card-title>
  <v-card-text>
    <v-data-table
    :headers="docHeadList"
    :items="docItemList"
    hide-default-footer
    disable-pagination
    dense
    :mobile-breakpoint="0">
    <template slot="item" slot-scope="props">
      <tr>
        <td style="font-size: 12px;">{{ props.index + 1 }}</td>
        <td style="font-size: 12px;">{{ props.item.file_name }}</td>
        <td><a :href="handy.loadImg(props.item.file_url)" download style="text-decoration: none;">
          <v-btn small icon class="mr-1 info grey--text text--lighten-4">
            <v-icon small>mdi-download</v-icon>
          </v-btn>
        </a></td>
        <td style="font-size: 12px;">{{ props.item.sales_review_doc_remarks }}</td>
      </tr>
    </template>
  </v-data-table>
</v-card-text>
</v-card>
</v-card-text>
</v-card>
</v-dialog>

<!-- 15. project contract view based on base id -->
<v-dialog scrollable v-model="showContractViewAsPdf" max-width="900px">
  <v-card>
    <v-card-title class="py-2 grey lighten-3">
      Project Contract
      <v-spacer></v-spacer>
      <v-btn icon small @click="showContractViewAsPdf = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <v-card flat>
          <v-card-text class="pa-0">
            <!-- 1st and 2nd view-->
            <v-flex xs12 style="padding-right: 5px;" v-if="attTab === 'tab-0' || attTab === 'tab-1'">
              <v-layout row wrap>
                <v-flex xs12 v-if="projContractView[0] && projContractView[0].length > 0 && projContractView[0][0].proj_contract_sub_category">
                  <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                    <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;font-weight: semi-bold;">{{projContractView[0][0].heading}}</div>
                    <v-data-table
                    :headers="techHeaders"
                    hide-default-header
                    :items="projContractView[0]"
                    disable-sort
                    hide-default-footer
                    dense
                    disable-pagination>
                    <template v-slot:header="{ props: { headers } }">
                      <thead>
                        <tr>
                          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
                        </tr>
                      </thead>
                    </template>
                    <template slot="item" slot-scope="props">
                      <tr>
                        <td style="font-size: 12px; color:#000; border-bottom: 1px solid #bebebe; vertical-align: top; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
                        <td style="font-size: 12px; color:#000; border-bottom: 1px solid #bebebe; vertical-align: top; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
                        <td style="font-size: 12px; color:#000; border-bottom: 1px solid #bebebe; vertical-align: top; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                  <v-flex xs12>
                    <table width="100%" cellpadding="0" cellspacing="0">
                      <tbody>
                        <tr style="background-color: #fff; font-family: Arial, Helvetica, sans-serif; color: #000;">
                          <td style="font-size: 12px; padding: 4px 16px; width: 368px;">Sub Total</td>
                          <td style="font-size: 12px; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(projContractView[0].total_amount) }}
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </v-flex>
                  <v-flex xs12 v-if="attTab === 'tab-0'">
                    <table width="100%" cellpadding="0" cellspacing="0">
                      <tbody>
                        <tr style="font-family: Arial, Helvetica, sans-serif; color: #000;" v-for="(mgmt, i) in projContractView[1]" :key="i">
                          <td style="font-size: 12px; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                          <td style="font-size: 12px; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                          </td>
                          <td></td>
                        </tr>
                        <tr style="background-color: #93f0cf; font-family: Arial, Helvetica, sans-serif; color: #09391f;">
                          <td style="font-size: 12px; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                          <td style="font-size: 12px; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(projContractView[0].before_gst) }}
                          </td>
                          <td></td>
                        </tr>
                        <tr style="font-family: Arial, Helvetica, sans-serif; color: #000;" v-for="gst in projContractView[2]" :key="gst.gst_amt">
                          <td style="font-size: 12px; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                          <td style="font-size: 12px; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(gst.tax_amt) }}
                          </td>
                          <td></td>
                        </tr>
                        <tr style="background-color: #44cb82; font-family: Arial, Helvetica, sans-serif; color: #fff;">
                          <td style="font-size: 12px; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[0][0].heading.substring(10, projContractView[0][0].heading.length)}} Grand Total with GST</td>
                          <td style="font-size: 12px; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(projContractView[0].gst_tax_amt) }}
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </v-flex>
                </v-flex>
              </v-flex>
              <div style="page-break-after:always; clear:both"></div>
              <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[3] && projContractView[3].length > 0 && projContractView[3][0].staff_role">
                <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                  <div style="background-color: #4570d6; padding: 4px 0px; color: #fff; text-align: center; font-family: Arial, Helvetica, sans-serif;">{{projContractView[3][0].heading}}</div>
                  <v-flex xs12>
                    <v-flex xs12 v-for="(cat, i) in category" :key="i" v-if="projContractView[3].filter(rec => rec.role_cat === cat).length > 0">
                      <div style="padding: 4px 0px; font-size: 12px; font-family: Arial, Helvetica, sans-serif; background-color: #71c1f5; color: #000; text-align: center;">
                        {{handy.startWithUpper(cat.toLowerCase())}}
                      </div>
                      <v-data-table
                      :headers="manpowerHeaders"
                      hide-default-header
                      :items="projContractView[3].filter(rec => rec.role_cat === cat)"
                      hide-default-footer
                      disable-sort
                      dense
                      disable-pagination
                      >
                      <template v-slot:header="{ props: { headers } }">
                        <thead>
                          <tr>
                            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 150px; text-align: left;">{{headers[0].text}}</th>
                            <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                            <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[2].text}}</th>
                            <th style="background-color: #cee6f5;font-size: 12px; padding-right: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[3].text}}</th>
                            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[4].text}}</th>
                          </tr>
                        </thead>
                      </template>
                      <template slot="item" slot-scope="props">
                        <tr>
                          <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.staff_role }}</td>
                          <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.head_count }}</td>
                          <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amt_per_hc }}</td>
                          <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.total_hc_amt }}</td>
                          <td style="font-size: 12px; border-bottom: 1px solid #bebebe; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-flex>
                  <v-flex xs12>
                    <table width="100%" cellpadding="0" cellspacing="0">
                      <tbody>
                        <tr style="color: #000;">
                          <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Sub Total</td>
                          <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(projContractView[3].total_amount) }}
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </v-flex>
                  <v-flex xs12 v-if="attTab === 'tab-0'">
                    <table width="100%" cellpadding="0" cellspacing="0">
                      <tbody>
                        <tr style="color: #000;" v-for="mgmt in projContractView[4]" :key="mgmt.Mgmt_fee_per">
                          <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.Mgmt_fee_per}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                          <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                          </td>
                          <td></td>
                        </tr>
                        <tr style="background-color: #93f0cf; color:#09391f;">
                          <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                          <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(projContractView[3].before_gst) }}
                          </td>
                          <td></td>
                        </tr>
                        <tr style="color: #000;" v-for="gst in projContractView[5]" :key="gst.gst_amt">
                          <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                          <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(gst.tax_amt) }}
                          </td>
                          <td></td>
                        </tr>
                        <tr style="background-color: #44cb82; color: #fff;">
                          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[3][0].heading.substring(8, projContractView[3][0].heading.length)}} Grand Total with GST</td>
                          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(projContractView[3].gst_tax_amt) }}
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </v-flex>
                </v-flex>
              </v-flex>
            </v-flex>
            <div style="page-break-after:always; clear:both"></div>
            <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[6] && projContractView[6].length && projContractView[6][0].staff_role">
              <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[6][0].heading}}</div>
                <v-flex xs12 v-if="projContractView[6].filter(rec => rec.role_cat === 'SAFTY/SECURITY').length > 0">
                  <v-divider class="black"></v-divider>
                  <v-data-table
                  :headers="manpowerHeaders"
                  hide-default-header
                  :items="projContractView[6]"
                  disable-sort
                  hide-default-footer
                  dense
                  disable-pagination
                  >
                  <template v-slot:header="{ props: { headers } }">
                    <thead>
                      <tr>
                        <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 150px; text-align: left;">{{headers[0].text}}</th>
                        <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                        <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[2].text}}</th>
                        <th style="background-color: #cee6f5;font-size: 12px; padding-right: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[3].text}}</th>
                        <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[4].text}}</th>
                      </tr>
                    </thead>
                  </template>
                  <template slot="item" slot-scope="props">
                    <tr>
                      <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.staff_role }}</td>
                      <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.head_count }}</td>
                      <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amt_per_hc }}</td>
                      <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.total_hc_amt }}</td>
                      <td style="font-size: 12px; border-bottom: 1px solid #bebebe; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                    </tr>
                  </template>
                </v-data-table>
                <v-flex xs12>
                  <table width="100%" cellpadding="0" cellspacing="0">
                    <tbody>
                      <tr style="color: #000;">
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                          {{ handy.formatCur(projContractView[6].total_amount) }}
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </v-flex>
                <v-flex xs12 v-if="attTab === 'tab-0'">
                  <table width="100%" cellpadding="0" cellspacing="0">
                    <tbody>
                      <tr style="color: #000;" v-for="mgmt in projContractView[7]" :key="mgmt.Mgmt_fee_per">
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px; width: 100px;">Management fees ({{mgmt.Mgmt_fee_per}} % of {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                          {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                        </td>
                        <td></td>
                      </tr>
                      <tr style="background-color: #93f0cf; color:#09391f;">
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                          {{ handy.formatCur(projContractView[6].before_gst) }}
                        </td>
                        <td></td>
                      </tr>
                      <tr style="color: #000;" v-for="gst in projContractView[8]" :key="gst.gst_amt">
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                          {{ handy.formatCur(gst.tax_amt) }}
                        </td>
                        <td></td>
                      </tr>
                      <tr style="background-color: #44cb82; color: #fff;">
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[6][0].heading.substring(8, projContractView[6][0].heading.length)}} Grand Total with GST</td>
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                          {{ handy.formatCur(projContractView[6].gst_tax_amt) }}
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </v-flex>
              </v-flex>
            </v-flex>
          </v-flex>
          <div style="page-break-after:always; clear:both"></div>
          <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[9] && projContractView[9].length && projContractView[9][0].proj_contract_sub_category">
            <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
              <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[9][0].heading}}</div>
              <v-data-table
              :headers="techHeaders"
              hide-default-header
              disable-sort
              :items="projContractView[9]"
              hide-default-footer
              dense
              disable-pagination
              >
              <template v-slot:header="{ props: { headers } }">
                <thead>
                  <tr>
                    <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                    <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                    <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
                  </tr>
                </thead>
              </template>
              <template slot="item" slot-scope="props">
                <tr>
                  <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
                  <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
                  <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                </tr>
              </template>
            </v-data-table>
            <v-flex xs12>
              <table width="100%" cellpadding="0" cellspacing="0">
                <tbody>
                  <tr style="color: #000;">
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                      {{ handy.formatCur(projContractView[9].total_amount) }}
                    </td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </v-flex>
            <v-flex xs12 v-if="attTab === 'tab-0'">
              <table width="100%" cellpadding="0" cellspacing="0">
                <tbody>
                  <tr style="color: #000;" v-for="mgmt in projContractView[10]" :key="mgmt.Mgmt_fee_per">
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                      {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                    </td>
                    <td></td>
                  </tr>
                  <tr style="background-color: #93f0cf; color:#09391f;">
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                      {{ handy.formatCur(projContractView[9].before_gst) }}
                    </td>
                    <td></td>
                  </tr>
                  <tr style="color: #000;" v-for="gst in projContractView[11]" :key="gst.gst_amt">
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                      {{ handy.formatCur(gst.tax_amt) }}
                    </td>
                    <td></td>
                  </tr>
                  <tr style="background-color: #44cb82; color: #fff;">
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[9][0].heading.substring(21, projContractView[9][0].heading.length)}} Grand Total with GST</td>
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                      {{ handy.formatCur(projContractView[9].gst_tax_amt) }}
                    </td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </v-flex>
          </v-flex>
        </v-flex>
        <div style="page-break-after:always; clear:both"></div>
        <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[12] && projContractView[12].length && projContractView[12][0].proj_contract_sub_category">
          <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
            <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[12][0].heading}}</div>
            <v-data-table
            :headers="techHeaders"
            hide-default-header
            disable-sort
            :items="projContractView[12]"
            hide-default-footer
            dense
            disable-pagination
            >
            <template v-slot:header="{ props: { headers } }">
              <thead>
                <tr>
                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
                </tr>
              </thead>
            </template>
            <template slot="item" slot-scope="props">
              <tr>
                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
              </tr>
            </template>
          </v-data-table>
          <v-flex xs12>
            <table width="100%" cellpadding="0" cellspacing="0">
              <tbody>
                <tr style="color: #000;">
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                    {{ handy.formatCur(projContractView[12].total_amount) }}
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </v-flex>
          <v-flex xs12 v-if="attTab === 'tab-0'">
            <table width="100%" cellpadding="0" cellspacing="0">
              <tbody>
                <tr style="color: #000;" v-for="mgmt in projContractView[13]" :key="mgmt.Mgmt_fee_per">
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} % of {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                    {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                  </td>
                  <td></td>
                </tr>
                <tr style="background-color: #93f0cf; color:#09391f;">
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                    {{ handy.formatCur(projContractView[12].before_gst) }}
                  </td>
                  <td></td>
                </tr>
                <tr style="color: #000;" v-for="gst in projContractView[14]" :key="gst.gst_amt">
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                    {{ handy.formatCur(gst.tax_amt) }}
                  </td>
                  <td></td>
                </tr>
                <tr style="background-color: #44cb82; color: #fff;">
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[12][0].heading.substring(13, projContractView[12][0].heading.length)}} Grand Total with GST</td>
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                    {{ handy.formatCur(projContractView[12].gst_tax_amt) }}
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </v-flex>
        </v-flex>
      </v-flex>
      <div style="page-break-after:always; clear:both"></div>
      <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[15] && projContractView[15].length && projContractView[15][0].proj_contract_sub_category">
        <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
          <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[15][0].heading}}</div>
          <v-data-table
          :headers="techHeaders"
          hide-default-header
          disable-sort
          :items="projContractView[15]"
          hide-default-footer
          dense
          disable-pagination
          >
          <template v-slot:header="{ props: { headers } }">
            <thead>
              <tr>
                <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
              </tr>
            </thead>
          </template>
          <template slot="item" slot-scope="props">
            <tr>
              <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
              <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
              <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
            </tr>
          </template>
        </v-data-table>
        <v-flex xs12>
          <table width="100%" cellpadding="0" cellspacing="0">
            <tbody>
              <tr style="color: #000;">
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                  {{ handy.formatCur(projContractView[15].total_amount) }}
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </v-flex>
        <v-flex xs12 v-if="attTab === 'tab-0'">
          <table width="100%" cellpadding="0" cellspacing="0">
            <tbody>
              <tr style="color: #000;" v-for="mgmt in projContractView[16]" :key="mgmt.Mgmt_fee_per">
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                  {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                </td>
                <td></td>
              </tr>
              <tr style="background-color: #93f0cf; color:#09391f;">
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                  {{ handy.formatCur(projContractView[15].before_gst) }}
                </td>
                <td></td>
              </tr>
              <tr style="color: #000;" v-for="gst in projContractView[17]" :key="gst.gst_amt">
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                  {{ handy.formatCur(gst.tax_amt) }}
                </td>
                <td></td>
              </tr>
              <tr style="background-color: #44cb82; color: #fff;">
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[15][0].heading.substring(13, projContractView[15][0].heading.length)}} Grand Total with GST</td>
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                  {{ handy.formatCur(projContractView[15].gst_tax_amt) }}
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </v-flex>
      </v-flex>
    </v-flex>
    <div style="page-break-after:always; clear:both"></div>
    <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[18] && projContractView[18].length && projContractView[18][0].proj_contract_sub_category">
      <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
        <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[18][0].heading}}</div>
        <v-data-table
        :headers="techHeaders"
        hide-default-header
        disable-sort
        :items="projContractView[18]"
        hide-default-footer
        dense
        disable-pagination
        >
        <template v-slot:header="{ props: { headers } }">
          <thead>
            <tr>
              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
            </tr>
          </thead>
        </template>
        <template slot="item" slot-scope="props">
          <tr>
            <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
            <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
            <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
          </tr>
        </template>
      </v-data-table>
      <v-flex xs12>
        <table width="100%" cellpadding="0" cellspacing="0">
          <tbody>
            <tr style="color: #000;">
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur(projContractView[18].total_amount) }}
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </v-flex>
      <v-flex xs12 v-if="attTab === 'tab-0'">
        <table width="100%" cellpadding="0" cellspacing="0">
          <tbody>
            <tr style="color: #000;" v-for="mgmt in projContractView[19]" :key="mgmt.Mgmt_fee_per">
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
              </td>
              <td></td>
            </tr>
            <tr style="background-color: #93f0cf; color:#09391f;">
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur(projContractView[18].before_gst) }}
              </td>
              <td></td>
            </tr>
            <tr style="color: #000;" v-for="gst in projContractView[20]" :key="gst.gst_amt">
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur(gst.tax_amt) }}
              </td>
              <td></td>
            </tr>
            <tr style="background-color: #44cb82; color: #fff;">
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[18][0].heading.substring(5, projContractView[18][0].heading.length)}} Grand Total with GST</td>
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur(projContractView[18].gst_tax_amt) }}
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </v-flex>
    </v-flex>
  </v-flex>
  <div style="page-break-after:always; clear:both"></div>
  <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[21] && projContractView[21].length && projContractView[21][0].proj_contract_sub_category">
    <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
      <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[21][0].heading}}</div>
      <v-data-table
      :headers="techHeaders"
      hide-default-header
      disable-sort
      :items="projContractView[21]"
      hide-default-footer
      dense
      disable-pagination
      >
      <template v-slot:header="{ props: { headers } }">
        <thead>
          <tr>
            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
          </tr>
        </thead>
      </template>
      <template slot="item" slot-scope="props">
        <tr>
          <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
          <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
          <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
        </tr>
      </template>
    </v-data-table>
    <v-flex xs12>
      <table width="100%" cellpadding="0" cellspacing="0">
        <tbody>
          <tr style="color: #000;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[21].total_amount) }}
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </v-flex>
    <v-flex xs12 v-if="attTab === 'tab-0'">
      <table width="100%" cellpadding="0" cellspacing="0">
        <tbody>
          <tr style="color: #000;" v-for="mgmt in projContractView[22]" :key="mgmt.Mgmt_fee_per">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
            </td>
            <td></td>
          </tr>
          <tr style="background-color: #93f0cf; color:#09391f;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[21].before_gst) }}
            </td>
            <td></td>
          </tr>
          <tr style="color: #000;" v-for="gst in projContractView[23]" :key="gst.gst_amt">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(gst.tax_amt) }}
            </td>
            <td></td>
          </tr>
          <tr style="background-color: #44cb82; color: #fff;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[21][0].heading.substring(20, projContractView[21][0].heading.length)}} Grand Total with GST</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[21].gst_tax_amt) }}
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </v-flex>
  </v-flex>
</v-flex>
<div style="page-break-after:always; clear:both"></div>
<v-flex xs12 style="padding-top: 8px;" v-if="projContractView[24] && projContractView[24].length && projContractView[24][0].proj_contract_sub_category">
  <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
    <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[24][0].heading}}</div>
    <v-data-table
    :headers="techHeaders"
    hide-default-header
    disable-sort
    :items="projContractView[24]"
    hide-default-footer
    dense
    disable-pagination
    >
    <template v-slot:header="{ props: { headers } }">
      <thead>
        <tr>
          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
        </tr>
      </thead>
    </template>
    <template slot="item" slot-scope="props">
      <tr>
        <td style="font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
        <td style="font-size: 12px; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
        <td style="font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
      </tr>
    </template>
  </v-data-table>
  <v-flex xs12>
    <table width="100%" cellpadding="0" cellspacing="0">
      <tbody>
        <tr style="color: #000;">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(projContractView[24].total_amount) }}
          </td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </v-flex>
  <v-flex xs12 v-if="attTab === 'tab-0'">
    <table width="100%" cellpadding="0" cellspacing="0">
      <tbody>
        <tr style="color: #000;" v-for="mgmt in projContractView[25]" :key="mgmt.Mgmt_fee_per">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
          </td>
          <td></td>
        </tr>
        <tr style="background-color: #93f0cf; color:#09391f;">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(projContractView[24].before_gst) }}
          </td>
          <td></td>
        </tr>
        <tr style="color: #000;" v-for="gst in projContractView[26]" :key="gst.gst_amt">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(gst.tax_amt) }}
          </td>
          <td></td>
        </tr>
        <tr style="background-color: #44cb82; color: #fff;">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[24][0].heading.substring(9, projContractView[24][0].heading.length)}} Grand Total with GST</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(projContractView[24].gst_tax_amt) }}
          </td>
          <td></td>
        </tr>
        <tr style="background-color: #44cb82; color: #fff;">
          <td colspan="3"></td>
        </tr>
      </tbody>
    </table>
  </v-flex>
</v-flex>
</v-flex>
<!-- SUMMARY -->
<div style="page-break-after:always; clear:both"></div>
<v-flex xs12 style="padding-top: 8px; padding-bottom: 12px;" v-if="projContractView[27] && projContractView[27][0].sub_total">
  <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
    <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">SUMMARY</div>
    <table width="100%" cellpadding="0" cellspacing="0">
      <tbody>
        <tr style="color: #000;">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(projContractView[27][0].sub_total) }}
          </td>
          <td></td>
        </tr>
        <tr style="color: #000;">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management Fee</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(projContractView[27][0].mgmt_fee) }}
          </td>
          <td></td>
        </tr>
        <tr style="background-color: #93f0cf; color:#09391f;">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(projContractView[27][0].before_gst) }}
          </td>
          <td></td>
        </tr>
        <tr style="color: #000;">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(projContractView[27][0].tax_amt) }}
          </td>
          <td></td>
        </tr>
        <tr style="background-color: #44cb82; color: #fff;">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total After GST</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(projContractView[27][0].after_gst) }}
          </td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </v-flex>
</v-flex>
<v-flex xs12 v-else>
  <div>
    No Data Available
  </div>
</v-flex>
</v-layout>
</v-flex>

<!-- 3rd view -->
<v-flex xs12 style="padding-right: 5px;" v-if="attTab === 'tab-2'">
  <v-layout row wrap>
    <v-flex xs12 style="border: 1px solid black; border-radius: 0px;" v-if="projContractView[27] && projContractView[27][0].sub_total">
      <v-data-table
      :headers="manpowerHeaders"
      hide-default-header
      disable-sort
      :items="projContractView[0].concat(projContractView[3]).concat(projContractView[6]).concat(projContractView[9]).concat(projContractView[12]).concat(projContractView[15]).concat(projContractView[18]).concat(projContractView[21]).concat(projContractView[24])"
      hide-default-footer
      dense
      disable-pagination>
      <template v-slot:header="{ props: { headers } }">
        <thead>
          <tr>
            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 150px; text-align: left;">{{headers[0].text}}</th>
            <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
            <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[2].text}}</th>
            <th style="background-color: #cee6f5;font-size: 12px; padding-right: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[3].text}}</th>
            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[4].text}}</th>
          </tr>
        </thead>
      </template>
      <template slot="item" slot-scope="props">
        <tr v-if="props.item.staff_role || props.item.proj_contract_sub_category">
          <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.staff_role ? props.item.staff_role : props.item.proj_contract_sub_category }}</td>
          <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.head_count ? props.item.head_count : 1 }}</td>
          <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amt_per_hc ? props.item.amt_per_hc : props.item.amount }}</td>
          <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.total_hc_amt ? props.item.total_hc_amt : props.item.amount }}</td>
          <td style="border-bottom: 1px solid #bebebe; font-size: 12px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-flex>
  <div style="page-break-after:always; clear:both"></div>
  <v-flex xs12 style="padding-top: 8px; padding-bottom: 12px;" v-if="projContractView[27] && projContractView[27][0].sub_total">
    <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
      <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">SUMMARY</div>
      <table width="100%" cellpadding="0" cellspacing="0">
        <tbody>
          <tr style="color: #000;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[27][0].sub_total) }}
            </td>
            <td></td>
          </tr>
          <tr style="color: #000;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management Fee</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[27][0].mgmt_fee) }}
            </td>
            <td></td>
          </tr>
          <tr style="background-color: #93f0cf; color:#09391f;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px; color:#09391f;">Total Before Tax</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[27][0].before_gst) }}
            </td>
            <td></td>
          </tr>
          <tr style="color: #000;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[27][0].tax_amt) }}
            </td>
            <td></td>
          </tr>
          <tr style="background-color: #44cb82; color: #fff;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total After GST</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[27][0].after_gst) }}
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </v-flex>
  </v-flex>
  <v-flex xs12 v-else>
    <div>
      No Data Available
    </div>
  </v-flex>
</v-layout>
</v-flex>

<!-- 4th view -->
<v-flex xs12 style="padding-right: 5px;" v-if="attTab === 'tab-3'">
  <v-layout row wrap>
    <v-flex xs12 v-if="(projContractView[3] && projContractView[3].length > 0  && projContractView[3][0].staff_role) || (projContractView[6] && projContractView[6].length > 0 && projContractView[6][0].staff_role)">
      <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
        <div style="background-color: #4570d6; padding: 4px 0px; color: #fff; text-align: center; font-family: Arial, Helvetica, sans-serif;">MANPOWER</div>
        <v-data-table
        :headers="manpowerHeaders"
        hide-default-header
        disable-sort
        :items="projContractView[3].concat(projContractView[6])"
        hide-default-footer
        dense
        disable-pagination>
        <template v-slot:header="{ props: { headers } }">
          <thead>
            <tr>
              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 150px; text-align: left;">{{headers[0].text}}</th>
              <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
              <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[2].text}}</th>
              <th style="background-color: #cee6f5;font-size: 12px; padding-right: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[3].text}}</th>
              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[4].text}}</th>
            </tr>
          </thead>
        </template>
        <template slot="item" slot-scope="props">
          <tr>
            <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.staff_role }}</td>
            <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.head_count }}</td>
            <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amt_per_hc }}</td>
            <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.total_hc_amt }}</td>
            <td style="border-bottom: 1px solid #bebebe; font-size: 12px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
          </tr>
        </template>
      </v-data-table>
      <v-flex xs12>
        <table width="100%" cellpadding="0" cellspacing="0">
          <tbody>
            <tr style="color: #000;">
              <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Sub Total</td>
              <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur((projContractView[3].total_amount ? projContractView[3].total_amount : 0) + (projContractView[6].total_amount ? projContractView[6].total_amount : 0)) }}
              </td>
              <td></td>
            </tr>
            <tr style="color: #000;">
              <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Management fees</td>
              <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur((projContractView[3].mgmt ? projContractView[3].mgmt : 0) + (projContractView[6].mgmt ? projContractView[6].mgmt : 0)) }}
              </td>
              <td></td>
            </tr>
            <tr style="background-color: #93f0cf; color:#09391f;">
              <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px; color:#09391f;">Total Before Tax</td>
              <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur((projContractView[3].before_gst ? projContractView[3].before_gst : 0) + (projContractView[6].before_gst ? projContractView[6].before_gst : 0)) }}
              </td>
              <td></td>
            </tr>
            <tr style="color: #000;">
              <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">GST</td>
              <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur((projContractView[3].tax_amt ? projContractView[3].tax_amt : 0) + (projContractView[6].tax_amt ? projContractView[6].tax_amt : 0)) }}
              </td>
              <td></td>
            </tr>
            <tr style="background-color: #44cb82; color: #fff;">
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total with GST</td>
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur((projContractView[3].gst_tax_amt ? projContractView[3].gst_tax_amt : 0) + (projContractView[6].gst_tax_amt ? projContractView[6].gst_tax_amt : 0)) }}
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </v-flex>
    </v-flex>
  </v-flex>
  <v-flex xs12 style="padding-top: 6px;" v-if="projContractView[28] && projContractView[28][0].total_amount">
    <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
      <div style="background-color: #4570d6; padding: 4px 0px; color: #fff; text-align: center; font-family: Arial, Helvetica, sans-serif;">SERVICE</div>
      <v-data-table
      :headers="techHeaders"
      hide-default-header
      disable-sort
      :items="projContractView[0].concat(projContractView[9]).concat(projContractView[12]).concat(projContractView[15]).concat(projContractView[18]).concat(projContractView[21]).concat(projContractView[24])"
      hide-default-footer
      dense
      disable-pagination>
      <template v-slot:header="{ props: { headers } }">
        <thead>
          <tr>
            <th style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
            <th style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
            <th style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
          </tr>
        </thead>
      </template>
      <template slot="item" slot-scope="props">
        <tr>
          <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
          <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
          <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
        </tr>
      </template>
    </v-data-table>
    <v-flex xs12>
      <table width="100%" cellpadding="0" cellspacing="0">
        <tbody>
          <tr style="color: #000;">
            <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Sub Total</td>
            <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[28][0].total_amount) }}
            </td>
            <td></td>
          </tr>
          <tr style="color: #000;">
            <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Management fees</td>
            <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[28][0].mgmt_fee) }}
            </td>
            <td></td>
          </tr>
          <tr style="background-color: #93f0cf; color:#09391f;">
            <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px; color:#09391f;">Total Before Tax</td>
            <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[28][0].before_gst) }}
            </td>
            <td></td>
          </tr>
          <tr style="color: #000;">
            <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">GST</td>
            <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[28].tax_amt) }}
            </td>
            <td></td>
          </tr>
          <tr style="background-color: #44cb82; color: #fff;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total with GST</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[28][0].total_amt) }}
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </v-flex>
  </v-flex>
</v-flex>
</v-layout>
</v-flex>
</v-card-text>
</v-card>
</v-flex>
</v-card-text>
<v-card-actions class="pt-0">
  <v-flex xs12>
    <v-tabs v-model="attTab" show-arrows>
      <v-tab v-for="(attitem, n) in viewTabItems" :key="n" :href="`#tab-${n}`" @click="changeView(attitem)">
        {{attitem}}
      </v-tab>
    </v-tabs>
  </v-flex>
</v-card-actions>
</v-card>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-col>
</v-row>
</v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'

export default {
  data () {
    return {
      // common
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      search: '',
      lAction: 'view',
      config: config,
      handy: handy,
      rules: handy.rules,
      // front end sales
      lSalesList: [],
      salesHead: [
        { text: 'SNo.', value: '', class: 'uniformchipinfo white--text' },
        { text: 'Current Department', value: 'current_dept', class: 'uniformchipinfo white--text' },
        { text: 'Version No.', value: 'version_no', class: 'uniformchipinfo white--text' },
        { text: 'Project Contract Version', value: 'project_contract_version', class: 'uniformchipinfo white--text' },
        { text: 'Project Contract Value', value: 'contract_amt_with_tax', class: 'uniformchipinfo white--text' }
      ],
      dlgDate: false,
      isClosedProject: false,
      selTab: 0,
      selTab1: 1,
      // sales base
      lSalesBase: [],
      projList: [],
      commList: [],
      salesProjList: [],
      projContractList: [],
      // sales review section
      salesReviewItemList: [],
      salesReviewHeadList: [
        { text: 'Sno', value: 'sno', width: '75px' },
        { text: 'Description', value: 'mi_sales_sub_cat', width: '300px' },
        { text: 'Uniservice Remark', value: 'sales_review_uniservice_remarks' }
      ],
      salesReviewDetList: [],
      selected: [],
      showListOfSalesReviewDet: false,
      salesReviewDetHeadList: [
        { text: 'Category', value: 'mi_sales_cat', sortable: false },
        { text: 'Information/ Questionnaire', value: 'mi_sales_sub_cat', sortable: false }
      ],
      beingSaved: false,
      salesCat: [],
      voiceOfCustItemList: [],
      voiceOfCustDetList: [],
      showListOfVoiceofCustDet: false,
      voiceofCustDetHeadList: [
        { text: 'Questionnaire', value: 'mi_voice_of_customer', sortable: false }
      ],
      custExpectItemList: [],
      custExpectHeadList: [
        { text: 'Sno', value: 'sno', width: '75px' },
        { text: 'Category', value: 'category', width: '200px' },
        { text: 'Expectation Description', value: 'mi_cust_expectation', width: '300px' },
        { text: 'Frequency', value: 'mi_freq', width: '100px', sortable: false },
        { text: 'Uniservice Remark', value: 'sales_review_cust_expect_remarks' }
      ],
      uniCommitItemList: [],
      docItemList: [],
      docHeadList: [
        { text: 'Sno', value: 'sno', width: '75px' },
        { text: 'Document File Name', value: 'mi_sales_sub_cat', width: '300px' },
        { text: 'Download', value: '', width: '100px', sortable: false },
        { text: 'Uniservice Remark', value: 'sales_review_uniservice_remarks' }
      ],
      custExpectDetList: [],
      custExpectDetHeadList: [
        { text: 'Category', value: 'category', sortable: false },
        { text: 'Customer Expectations Description', value: 'mi_customer_expectation', sortable: false },
        { text: 'Frequency', value: 'mi_freq', sortable: false }
      ],
      showListOfCustExpectDet: false,
      uniCommitDetList: [],
      showListOfUniCommitDet: false,
      uniCommitDetHeadList: [
        { text: 'Category', value: 'category', sortable: false },
        { text: 'Customer Expectations Description', value: 'mi_uniservice_commit', sortable: false },
        { text: 'Frequency', value: 'mi_freq', sortable: false }
      ],
      showSalesDocUpload: false,
      lUploadDoc: [],
      lSales: [],
      showSales: false,
      lVoice: [],
      showVoice: false,
      lCust: [],
      showCust: false,
      freqItem: [],
      showUniserviceCommit: false,
      lUniCommit: [],
      commDetailsList: [],
      showCommunity: false,
      projDetailsList: [],
      showProject: false,
      lVersion: null,
      versionList: [],
      disableSubmitButton: false,
      showSalesReview: false,
      projContractDetailsList: [],
      showProjectContract: false,
      projContractView: [],
      viewTabItems: ['Proposal breakup', 'end-to-end proposal', 'compressed view', 'M&S view'],
      attTab: 'tab-0',
      showContractViewAsPdf: false,
      techHeaders: [
        { text: 'Category' , value: 'proj_contract_sub_category' },
        { text: 'Total' , value: 'amount', sortable: false },
        { text: 'Comments' , value: 'comments', sortable: false }
      ],
      manpowerHeaders: [
        { text: 'Category' , value: 'staff_role' },
        { text: 'No of Person' , value: 'head_count' },
        { text: 'Rate/Person' , value: 'amt_per_hc' },
        { text: 'Total' , value: 'total_hc_amt' },
        { text: 'Comments' , value: 'comments' }
      ],
      category: ['MANAGEMENT/OFFICE', 'TECHNICAL SERVICES', 'SOFT SERVICES', 'OTHERS']
    }
  },
  created () {
    this.loadSalesBaseDetails()
  },
  methods: {
    searchProjectTile (curRec) {
      if (curRec.length > 1) {
        var tmpVar = this.salesProjList.filter(rec => rec.toLowerCase().includes(curRec.toLowerCase()))
        if (tmpVar.length > 0) {
          this.salesProjList = []
          this.salesProjList = tmpVar
        } else {
          this.salesProjList = []
        }
      } else {
        this.loadSalesBaseDetails()
      }
    },
    showClosedProjects () {
      this.isClosedProject = !this.isClosedProject
      this.loadSalesBaseDetails()
    },
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    prepareCreate () {
      this.lSalesBase = {
        proj_contract_base_id: null,
        comm_pair: { comm_name: '', comm_id: null },
        proj_pair: { proj_id: null, proj_name: '' },
        vendor_id: config.VENDOR_ID,
        on_boarding_date: null
      }
      this.lVersion = null
      this.lAction = 'create'
      this.loadCommunity()
    },
    loadCommunity () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.commList = []
      this.axios.get(config.API_URL + '/getProjectCommList/', qry)
      .then(response => {
        this.commList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadProjectBasedOnCommId (curComm) {
      if (curComm.comm_pair && curComm.comm_pair.comm_id) {
        var qry = {
          params: {
            comm_id: curComm.comm_pair.comm_id
          }
        }
        this.projList = []
        this.axios.get(config.API_URL + '/getProjectListBasedOnCommId/', qry)
        .then(response => {
          this.projList = response.data
        })
        .catch(err => {
          this.msg(err, 0)
        })
      }
    },
    loadProjectContractBasedOnProjId (curProj) {
      if (curProj.proj_pair && curProj.proj_pair.proj_id) {
        var qry = {
          params: {
            proj_id: curProj.proj_pair.proj_id
          }
        }
        this.projContractList = []
        this.axios.get(config.API_URL + '/getProjectContractBasedOnProjId/', qry)
        .then(response => {
          this.projContractList = response.data
        })
        .catch(err => {
          this.msg(err, 0)
        })
      }
    },
    saveSalesReviewBaseChanges (action) {
      if (!this.lSalesBase.comm_pair.comm_id || !this.lSalesBase.proj_pair.proj_id) {
        this.msg('Please select the community and project both', 0)
      } else {
        if (this.$refs.pForm.validate()) {
          this.lSalesBase.vendor_id = config.VENDOR_ID
          this.lSalesBase.created_by = config.EMP_ID
          this.axios.post(config.API_URL + '/salesReviewBase/' + action, this.lSalesBase)
          .then(response => {
            this.lSalesBase.mi_base_id = response.data
            this.lVersion = response.data
            this.loadSalesReviewDetails()
            this.msg('Saved Successfully', 1)
          })
          .catch(err => {
            this.msg(err, 0)
          })
        }
      }
    },
    deleteSalesBaseTable (curSales) {
      if (!confirm('Sure, you want to delete the Sales Review with name "' + curSales.proj_pair.proj_name + ' ?')) {
        return
      }
      // up in db
      curSales.vendor_id = config.VENDOR_ID
      this.axios.post(config.API_URL + '/salesReviewBase/delete', curSales)
      .then(response => {
        // refresh stats
        this.loadSalesBaseDetails()
        this.lAction = 'view'
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadSalesBaseDetails () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          is_closed_project: this.isClosedProject
        }
      }
      this.lSalesList = []
      this.axios.get(config.API_URL + '/getListOfSalesReviewBaseByVendorId/', qry)
      .then(response => {
        this.lSalesList = response.data
        this.salesProjList = handy.unique(this.lSalesList.map(rec => rec.proj_name))
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareUpdate (curRec) {
      this.lSalesBase = Object.assign({}, curRec)
      this.loadCommunity()
      this.lSalesBase.comm_pair = { comm_id: curRec.comm_id, comm_name: curRec.comm_name }
      this.lSalesBase.proj_pair = { proj_id: curRec.proj_id, proj_name: curRec.proj_name }
      this.lVersion = this.lSalesBase.mi_base_id
      this.lSalesBase.on_boarding_date = curRec.on_boarding_date ? handy.formatDBDate(curRec.on_boarding_date) : ''
      this.loadProjectBasedOnCommId (this.lSalesBase)
      this.loadProjectContractBasedOnProjId (this.lSalesBase)
      this.loadSalesReviewDetails()
      this.lAction = 'update'
    },
    parepareSalesReviewImport (filterList) {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          filter: filterList.length > 0 ? filterList.map(rec => rec.sales_review_sub_cat_id) : null
        }
      }
      this.salesReviewDetList = []
      this.axios.get(config.API_URL + '/getListOfSalesReviewDetailBasedOnGivenBaseId/', qry)
      .then(response => {
        this.salesReviewDetList = response.data
        this.selected = []
        this.showListOfSalesReviewDet = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    importToSalesReview (curSelectedArray) {
      if (curSelectedArray.length > 0) {
        curSelectedArray.push({
          mi_base_id: this.lSalesBase.mi_base_id
        })
        this.beingSaved = true
        this.axios.post(config.API_URL + '/salesImport/', curSelectedArray)
        .then(response => {
          if (response.data === 'success') {
            this.msg('Imported Successfully', 1)
          } else {
            this.msg(response.data, 0)
          }
          this.showListOfSalesReviewDet = false
          this.beingSaved = false
          setTimeout(() => {
            this.loadSalesReviewDetails()
          }, 500)
        })
        .catch(err => {
          this.msg(err.response.data, 0)
        })
      } else {
        this.msg('Please select from the given list to import it.', 0)
      }
    },
    loadSalesReviewDetails () {
      var path = require('path')
      this.loadListOfVersionForParticularSalesReview()
      var qry = {
        params: {
          mi_base_id: this.lSalesBase.mi_base_id
        }
      }

      this.salesReviewItemList = []
      this.axios.get(config.API_URL + '/getListOfSalesReviewDetailsBasedonBaseId/', qry)
      .then(response => {
        this.salesReviewItemList = response.data
        this.salesCat = handy.unique(this.salesReviewItemList.map(rec => rec.sales_review_cat)).sort()
      })

      this.voiceOfCustItemList = []
      this.axios.get(config.API_URL + '/getListOfVoiceofCustDetailsBasedonBaseId/', qry)
      .then(response => {
        this.voiceOfCustItemList = response.data
      })

      this.custExpectItemList = []
      this.axios.get(config.API_URL + '/getListOfCustExpectDetailsBasedonBaseId/', qry)
      .then(response => {
        this.custExpectItemList = response.data
      })

      this.uniCommitItemList = []
      this.axios.get(config.API_URL + '/getListOfUniCommitDetailsBasedonBaseId/', qry)
      .then(response => {
        this.uniCommitItemList = response.data
      })

      this.docItemList = []
      this.axios.get(config.API_URL + '/getListOfDocUploadsBasedonBaseId/', qry)
      .then(response => {
        response.data.forEach((rec) => {
          this.docItemList.push({
            file_url: rec.file_url,
            file_name: rec.file_url ? path.basename(rec.file_url) : '',
            is_selected: true,
            is_changed: false,
            sales_review_doc_remarks: rec.sales_review_doc_remarks
          })
        })
      })
    },
    parepareVoiceofCustImport (filterList) {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          filter: filterList.length > 0 ? filterList.map(rec => rec.mi_voice_of_customer_id) : null
        }
      }
      this.voiceOfCustDetList = []
      this.axios.get(config.API_URL + '/getListOfVoiceofCustDetailBasedOnBaseId/', qry)
      .then(response => {
        this.voiceOfCustDetList = response.data
        this.selected = []
        this.showListOfVoiceofCustDet = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    importToVoiceOfCust (curSelectedArray) {
      if (curSelectedArray.length > 0) {
        curSelectedArray.push({
          mi_base_id: this.lSalesBase.mi_base_id
        })
        this.beingSaved = true
        this.axios.post(config.API_URL + '/voiceOfCustImport/', curSelectedArray)
        .then(response => {
          if (response.data === 'success') {
            this.msg('Imported Successfully', 1)
          } else {
            this.msg(response.data, 0)
          }
          this.showListOfVoiceofCustDet = false
          this.beingSaved = false
          setTimeout(() => {
            this.loadSalesReviewDetails()
          }, 500)
        })
        .catch(err => {
          this.msg(err.response.data, 0)
        })
      } else {
        this.msg('Please select from the given list to import it.', 0)
      }
    },
    parepareCustExpectImport (filterList) {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          filter: filterList.length > 0 ? filterList.map(rec => rec.mi_customer_expectation_id) : null
        }
      }
      this.custExpectDetList = []
      this.axios.get(config.API_URL + '/getListOfCustExpectDetailBasedOnBaseId/', qry)
      .then(response => {
        this.custExpectDetList = response.data
        this.selected = []
        this.showListOfCustExpectDet = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    importToCustExpect (curSelectedArray) {
      if (curSelectedArray.length > 0) {
        curSelectedArray.push({
          mi_base_id: this.lSalesBase.mi_base_id
        })
        this.beingSaved = true
        this.axios.post(config.API_URL + '/custExpectImport/', curSelectedArray)
        .then(response => {
          if (response.data === 'success') {
            this.msg('Imported Successfully', 1)
          } else {
            this.msg(response.data, 0)
          }
          this.showListOfCustExpectDet = false
          this.beingSaved = false
          setTimeout(() => {
            this.loadSalesReviewDetails()
          }, 500)
        })
        .catch(err => {
          this.msg(err.response.data, 0)
        })
      } else {
        this.msg('Please select from the given list to import it.', 0)
      }
    },
    parepareUniCommitImport (filterList) {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          filter: filterList.length > 0 ? filterList.map(rec => rec.mi_uniservice_commit_id) : null
        }
      }
      this.uniCommitDetList = []
      this.axios.get(config.API_URL + '/getListOfUniCommitmentDetailBasedOnBaseId/', qry)
      .then(response => {
        this.uniCommitDetList = response.data
        this.selected = []
        this.showListOfUniCommitDet = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    importToUniCommitment (curSelectedArray) {
      if (curSelectedArray.length > 0) {
        curSelectedArray.push({
          mi_base_id: this.lSalesBase.mi_base_id
        })
        this.beingSaved = true
        this.axios.post(config.API_URL + '/uniCommitImport/', curSelectedArray)
        .then(response => {
          if (response.data === 'success') {
            this.msg('Imported Successfully', 1)
          } else {
            this.msg(response.data, 0)
          }
          this.showListOfUniCommitDet = false
          this.beingSaved = false
          setTimeout(() => {
            this.loadSalesReviewDetails()
          }, 500)
        })
        .catch(err => {
          this.msg(err.response.data, 0)
        })
      } else {
        this.msg('Please select from the given list to import it.', 0)
      }
    },
    parepareUploadDocuments () {
      this.lUploadDoc = {
        mi_base_id: this.lSalesBase.mi_base_id,
        source: "Sales",
        sales_review_doc_remarks: ''
      }
      this.showSalesDocUpload = true
    },
    pickFile () {
      this.$refs.fileInput.click()
    },
    loadFilesFromFileBrowser (curProject) {
      let currentDate = new Date()
      let time = currentDate.getHours() + "-" + currentDate.getMinutes() + "-" + currentDate.getSeconds()
      const files = event.target.files
      if (!curProject.files) {
        curProject.files = []
      }
      Array.from(files).forEach((file) => {
        const fileReader = new FileReader()
        const getResult = new Promise(resolve => {
          fileReader.onload = e => {
            curProject.files.push({
              file_url: e.target.result.split(',')[1],
              file_name: file.name.split('.')[0] + '_' + handy.formatDBDate(currentDate) + '_' + time + '.' + file.name.split('.')[1],
              is_selected: true,
              is_changed: true
            })
            this.$forceUpdate()
          }
        })
        fileReader.readAsDataURL(file)
        return getResult.then(file => {
          return file
        })
      })
    },
    removeSelectedFile (curFile) {
      curFile.is_selected = false
      this.$forceUpdate()
    },
    saveUploadedDocs () {
      this.axios.post(config.API_URL + '/salesReviewBase/attach', this.lUploadDoc)
      .then(response => {
        this.msg('Saved Successfully', 1)
        this.showSalesDocUpload = false
        this.loadSalesReviewDetails()
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareCreateSales () {
      this.lSales = {
        mi_sales_cat: '',
        mi_sales_sub_cat: '',
        sales_review_uniservice_remarks: '',
        source: "Sales",
        mi_base_id: this.lSalesBase.mi_base_id,
        action: 'create'
      }
      this.showSales = true
    },
    pushSalesChanges () {
      if (this.lSales.action === 'create') {
        this.salesReviewItemList.push(this.lSales)
        this.salesCat = handy.unique(this.salesReviewItemList.map(rec => rec.sales_review_cat)).sort()
      } else {
        var idx = this.salesReviewItemList.findIndex(obj => obj.sales_review_id === this.lSales.sales_review_id)
        Object.assign(this.salesReviewItemList[idx], this.lSales)
      }
      this.msg('Pushed Successfully', 1)
      this.showSales = false
    },
    prepareCreateVoiceofCust () {
      this.lVoice = {
        sales_review_voice_of_cust: '',
        sales_review_voice_of_cust_remarks: '',
        source: "Sales",
        mi_base_id: this.lSalesBase.mi_base_id,
        action: 'create'
      }
      this.showVoice = true
    },
    pushVoiceChanges () {
      if (this.lVoice.action === 'create') {
        this.voiceOfCustItemList.push(this.lVoice)
      } else {
        var idx = this.voiceOfCustItemList.findIndex(obj => obj.sales_review_voice_of_cust_id === this.lVoice.sales_review_voice_of_cust_id)
        Object.assign(this.voiceOfCustItemList[idx], this.lVoice)
      }
      this.msg('Pushed Successfully', 1)
      this.showVoice = false
    },
    loadFrequency () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.freqItem = []
      this.axios.get(config.API_URL + '/getListOfFreqBasedonVendorId/', qry)
      .then(response => {
        this.freqItem = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareCreateCustExpect () {
      this.lCust = {
        mi_freq_id: null,
        mi_cust_expectation: '',
        category: '',
        sales_review_cust_expect_remarks: '',
        source: "Sales",
        mi_base_id: this.lSalesBase.mi_base_id,
        action: 'create'
      }
      this.loadFrequency()
      this.showCust = true
    },
    pushCustChanges () {
      this.lCust.mi_freq = this.freqItem.filter(rec => rec.mi_freq_id === this.lCust.mi_freq_id)[0].mi_freq
      if (this.lCust.action === 'create') {
        this.custExpectItemList.push(this.lCust)
      } else {
        var idx = this.custExpectItemList.findIndex(obj => obj.mi_cust_expectation_id === this.lCust.mi_cust_expectation_id)
        Object.assign(this.custExpectItemList[idx], this.lCust)
      }
      this.msg('Pushed Successfully', 1)
      this.showCust = false
    },
    prepareCreateUniCommit () {
      this.lUniCommit = {
        mi_freq_id: null,
        sv_sales_review_uni_commit: '',
        category: '',
        sales_review_uni_commit_remarks: '',
        source: "Sales",
        mi_base_id: this.lSalesBase.mi_base_id,
        action: 'create'
      }
      this.loadFrequency()
      this.showUniserviceCommit = true
    },
    pushUniserviceCommitChanges () {
      this.lUniCommit.mi_freq = this.freqItem.filter(rec => rec.mi_freq_id === this.lUniCommit.mi_freq_id)[0].mi_freq
      if (this.lUniCommit.action === 'create') {
        this.lUniCommit.sv_sales_review_uni_commit_id = null
        this.uniCommitItemList.push(this.lUniCommit)
      } else {
        var idx = this.uniCommitItemList.findIndex(obj => obj.mi_uni_commit_id === this.lUniCommit.mi_uni_commit_id)
        Object.assign(this.uniCommitItemList[idx], this.lUniCommit)
      }
      this.msg('Pushed Successfully', 1)
      this.showUniserviceCommit = false
    },
    SaveAllTheSalesChanges () {
      this.axios.post(config.API_URL + '/salesReviewSales/', this.salesReviewItemList)
      .then(response => {
        this.loadSalesReviewDetails()
      })
      .catch(err => {
        this.msg(err, 0)
      })

      this.axios.post(config.API_URL + '/salesReviewvoiceofcustomer/', this.voiceOfCustItemList)
      .then(response => {
        this.loadSalesReviewDetails()
      })
      .catch(err => {
        this.msg(err, 0)
      })

      this.axios.post(config.API_URL + '/salesReviewcustExpect/', this.custExpectItemList)
      .then(response => {
        this.loadSalesReviewDetails()
      })
      .catch(err => {
        this.msg(err, 0)
      })

      this.axios.post(config.API_URL + '/salesReviewUniCommit/', this.uniCommitItemList)
      .then(response => {
        this.loadSalesReviewDetails()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    showBasicInformationOfCommunity (curSaleBase) {
      if (curSaleBase.comm_pair && curSaleBase.comm_pair.comm_id) {
        var qry = {
          params: {
            comm_id: curSaleBase.comm_pair.comm_id
          }
        }
        this.commDetailsList = []
        this.axios.get(config.API_URL + '/getBasicInformationofCommunity/', qry)
        .then(response => {
          this.commDetailsList = response.data
          this.showCommunity = true
        })
        .catch(err => {
          this.msg(err, 0)
        })
      }
    },
    showBasicInformationOfProject (curSaleBase) {
      if (curSaleBase.proj_pair && curSaleBase.proj_pair.proj_id) {
        var qry = {
          params: {
            proj_id: curSaleBase.proj_pair.proj_id
          }
        }
        this.projDetailsList = []
        this.axios.get(config.API_URL + '/getBasicInformationofProject/', qry)
        .then(response => {
          this.projDetailsList = response.data
          this.showProject = true
        })
        .catch(err => {
          this.msg(err, 0)
        })
      }
    },
    showBasicInformationOfProjectContract (curSaleBase) {
      if (curSaleBase.proj_contract_base_id) {
        var qry = {
          params: {
            proj_contract_base_id: curSaleBase.proj_contract_base_id
          }
        }
        this.projContractDetailsList = []
        this.axios.get(config.API_URL + '/getBasicInformationofProjectContract/', qry)
        .then(response => {
          this.projContractDetailsList = response.data
          this.showProjectContract = true
        })
        .catch(err => {
          this.msg(err, 0)
        })
      }
    },
    loadListOfVersionForParticularSalesReview () {
      var qry = {
        params: {
          comm_id: this.lSalesBase.comm_pair.comm_id,
          proj_id: this.lSalesBase.proj_pair.proj_id
        }
      }
      this.versionList = []
      this.axios.get(config.API_URL + '/getListOfVersionListOfParticularSalesReview/', qry)
      .then(response => {
        this.versionList = response.data
        this.versionList.forEach(rec => {
          if (rec.mi_base_id === this.lSalesBase.mi_base_id) {
            if (rec.version.includes('Submit to Onboarding')) {
              this.disableSubmitButton = true
            } else {
              this.disableSubmitButton = false
            }
          }
        })
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    changeTheStatusOfCurrentSalesReview () {
      if (!this.lSalesBase.proj_contract_base_id) {
        this.msg('Please Select the project contract before submitting it to Onboarding', 0)
      } else if (this.docItemList.length === 0) {
        this.msg('Please Add the Documents releated to this project sales review before submitting it to Onboarding', 0)
      } else {
        if (!confirm('Sure, you want to Submit to Onboarding the Sales Review ?')) {
          return
        }
        // up in db
        this.lSalesBase.vendor_id = config.VENDOR_ID
        this.lSalesBase.submitted_by = config.EMP_ID
        this.axios.post(config.API_URL + '/salesReviewBase/Status', this.lSalesBase)
        .then(response => {
          // refresh stats
          this.loadSalesReviewDetails()
        })
        .catch(err => {
          this.msg(err, 0)
        })
      }
    },
    loadTheDetailsAndBaseThingsBasedOnSelectedVersion (curBaseId) {
      this.lSalesBase.mi_base_id = curBaseId
      if (this.lSalesBase.mi_base_id === curBaseId) {
        var qry = {
          params: {
            mi_base_id: this.lSalesBase.mi_base_id
          }
        }
        this.lSalesBase = []
        this.axios.get(config.API_URL + '/getListOfSalesReviewBaseId/', qry)
        .then(response => {
          this.lSalesBase = response.data
          this.lSalesBase.comm_pair = { comm_id: this.lSalesBase.comm_id, comm_name: this.lSalesBase.comm_name }
          this.lSalesBase.proj_pair = { proj_id: this.lSalesBase.proj_id, proj_name: this.lSalesBase.proj_name }
          this.lVersion = this.lSalesBase.mi_base_id
          this.loadSalesReviewDetails()
        })
        this.$forceUpdate()
      }
    },
    prepareSalesUpdate (curRec) {
      this.lSales = Object.assign({}, curRec)
      this.lSales.action = 'update'
      this.showSales = true
    },
    prepareVoiceUpdate (curRec) {
      this.lVoice = Object.assign({}, curRec)
      this.lVoice.action = 'update'
      this.showVoice = true
    },
    prepareCustExpectUpdate (curRec) {
      this.loadFrequency()
      this.lCust = Object.assign({}, curRec)
      this.lCust.action = 'update'
      this.showCust = true
    },
    prepareUniCommitUpdate (curRec) {
      this.loadFrequency()
      this.lUniCommit = Object.assign({}, curRec)
      this.lUniCommit.action = 'update'
      this.showUniserviceCommit = true
    },
    changeView (curTab) {
      if (curTab === 'Proposal breakup') {
        this.attTab = 'tab-0'
      } else if (curTab === 'end-to-end proposal') {
        this.attTab = 'tab-1'
      } else if (curTab === 'compressed view') {
        this.attTab = 'tab-2'
      } else {
        this.attTab = 'tab-3'
      }
    },
    prepareViewProjContract (curContract) {
      var qry = {
        params: {
          proj_contract_base_id: curContract.proj_contract_base_id
        }
      }
      this.axios.get(config.API_URL + '/getProjContractViewAsPdf/', qry)
      .then(response => {
        this.projContractView = response.data
        this.projContractView.forEach(rec => {
          if (rec.length) {
            if (!rec.total_amount) {
              rec.total_amount = 0
            }
            if (!rec.gst_amt || !rec.before_gst) {
              rec.gst_tax_amt = 0
              rec.tax_amt = 0
              rec.before_gst = 0
            }
            if (!rec.mgmt) {
              rec.mgmt = 0
            }
            rec.forEach(records => {
              if (records.amount) {
                rec.total_amount += records.amount
              }
              if (records.total_hc_amt) {
                rec.total_amount += records.total_hc_amt
              }
              rec.mgmt += records.Mgmt_fee_amt
              rec.tax_amt += records.tax_amt
              rec.before_gst = rec.total_amount + rec.mgmt
              rec.gst_tax_amt = rec.before_gst + rec.tax_amt
            })
          }
        })
        this.showContractViewAsPdf = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    }
  }
}
</script>
